export default function ApplicationSectionPage({ sectionTitle, sectionDescription }) {
  return (
    <section className="card sectionCard">
      <div className="cardTitle">{sectionTitle}</div>
      <p className="muted sectionDescription">{sectionDescription}</p>
      <p className="muted sectionHint">
        Coming soon...
      </p>
    </section>
  )
}
